import { nanoid } from 'nanoid';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { realEstateTransaction } from '@monestry-dev/schema';
import { postData } from '../../../../redux/reducers/data';
import { setMessage } from '../../../../redux/actions/message';
import { handleValidateAndDispatchAccount, handleConnectedDepositMode, maybeTriggerSync } from '../submitUtils';

dayjs.extend(utc);

export default async function handleRealEstateSubmit({ formValues, dispatch, setLoading, category }) {
  const flattened = await handleConnectedDepositMode({ ...formValues }, { dispatch });

  const { resultDispatch, payload } = await handleValidateAndDispatchAccount({ category, userInput: flattened, dispatch, setLoading });
  const accountId = resultDispatch?.payload?.accounts?.[0]?.id;

  if (accountId && flattened.name && flattened.date && flattened.originalPrice) {
    const dataArray = [
      realEstateTransaction.validateSync({
        id: nanoid(),
        accountId,
        date: dayjs.utc(flattened.date).startOf('day'),
        category: 'realEstate',
        originalPrice: flattened.originalPrice,
        currency: flattened.currency,
        price: null,
        amount: 1,
        transactionType: 'purchase',
        importFlag: 'post',
      }),
    ];
    try {
      await dispatch(postData({ data: dataArray, category: 'realEstate', accountId }));
    } catch (error) {
      setLoading(false);
      dispatch(setMessage('addTransactionManually'));
    }
  }

  if (accountId) {
    maybeTriggerSync({ payload, category, dispatch, accountId });
  }
}
